import React, { useEffect, useState } from 'react';
import { Star } from 'lucide-react';
import api from '@/lib/api';

export default function ReviewsSection({ lang }) {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    api.get('/reviews/public?featured=true')
      .then(({ data }) => setReviews(data || []))
      .catch(() => setReviews([]));
  }, []);

  if (!reviews.length) return null;

  return (
    <section className="py-24 md:py-32 bg-[#0F3530] text-white" data-testid="section-reviews">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24">
        <div className="text-center mb-16">
          <div className="overline text-[#C9A961] mb-4">{lang === 'it' ? 'Testimonianze' : 'Testimonials'}</div>
          <h2 className="font-serif text-4xl md:text-5xl font-light text-white">
            {lang === 'it' ? 'La voce dei nostri clienti' : 'Our clients\' voices'}
          </h2>
          <div className="divider-gold mt-8 mx-auto" style={{ width: 50 }} />
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
          {reviews.slice(0, 6).map((r) => (
            <article
              key={r.id}
              className="border border-white/15 p-8 hover:border-[#C9A961]/60 transition-all duration-500"
              data-testid={`review-card-${r.id}`}
            >
              <div className="flex gap-1 mb-5">
                {[1,2,3,4,5].map((n) => (
                  <Star key={n} size={14} fill={n <= r.rating ? '#EBBE6A' : 'none'} stroke="#EBBE6A" strokeWidth={1.5} />
                ))}
              </div>
              {r.title && (
                <h3 className="font-serif text-xl text-white mb-3 leading-snug">"{r.title}"</h3>
              )}
              <p className="text-sm text-white/75 leading-relaxed font-light italic mb-6 line-clamp-6">
                {r.body}
              </p>
              <div className="border-t border-white/10 pt-4">
                <div className="overline text-[#C9A961]">{r.author_name || (lang === 'it' ? 'Cliente Harizi' : 'Harizi customer')}</div>
                <div className="text-xs text-white/40 mt-1">
                  {new Date(r.created_at).toLocaleDateString(lang === 'it' ? 'it-IT' : 'en-GB', { year: 'numeric', month: 'long' })}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
